<div class="Auftrag" (keyup.enter)="UpdateOrder()">
  @if(Auftrag != null)
  {
  <div class="row AuftragInfoBody">
    <div class="col">
      <div class="row HeaderRow">
        <div class="col">
          <h2>
            Auftrag: {{ Auftrag?.key }} ({{ Auftrag?.status | statusText }})
            <span class="badge text-bg-secondary">{{Auftrag?.version }}</span>
            <span></span>
          </h2>
        </div>
      </div>
      <div class="row ContentRow">
        <div class="col">

          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="true" HeaderText="" *IsSpezialUser>
            <PflegegruppeSelect [(Pflegegruppe)]="Auftrag.pflegegruppe"></PflegegruppeSelect>
            <div class="form-check mb-3">
              <input name="InKlaerung" id="InKlaerung" class="form-check-input" type="checkbox"
                     [checked]="Auftrag.inKlaerung"
                     (change)="Auftrag.inKlaerung = !Auftrag.inKlaerung" />
              <label for="InKlaerung" class="form-check-label">in Klärung</label>
            </div>
            <div class="form-check mb-3">
              <input name="qc" id="qc" class="form-check-input" type="checkbox"
                     [checked]="Auftrag.qc"
                     (change)="Auftrag.qc = !Auftrag.qc" />
              <label for="qc" class="form-check-label">in QC/Leads</label>
            </div>
          </Auftrag-Card>
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="true" HeaderText="Kostenvoranschlag" *IsSpezialUser>

            <div class="row">
              @if(Auftrag.pflegegruppe == 52)
              {
              <div class="col">
                <Date-Select LabelText="Postversand" [(Date)]="Auftrag.versand.postVersand"></Date-Select>
              </div>
              }
              <div class="col">
                <Date-Select LabelText="eKV Antrag Versand" [(Date)]="Auftrag.ekv.versand"></Date-Select>

              </div>

              <div class="col">
                <Date-Select LabelText="genehmigt" [(Date)]="Auftrag.ekv.genehmigt"></Date-Select>
              </div>

            </div>
            @if(Auftrag.pflegegruppe == 51 || Auftrag.pflegegruppe == 54)
            {
            <div class="row">
              <div class="col-3">
                <!--Cehckbox PG51 Zuzahlung-->
                <div class="form-check mb-3">
                  <input name="PG51Zuzahlung" id="PG51Zuzahlung" class="form-check-input" type="checkbox"
                         [checked]="Auftrag.ekv.zuzahlungPG51"
                         (change)="Auftrag.ekv.zuzahlungPG51 = !Auftrag.ekv.zuzahlungPG51" />
                  <label for="PG51Zuzahlung" class="form-check-label">PG51 Zuzahlung</label>
                </div>
              </div>
              <div class="col-3">
                <div class="form-floating mb-3">
                  <input type="number" min="0" max="4" class="form-control" id="anzahlZuzalungPG51" [(ngModel)]="Auftrag.ekv.anzahlZuzalungPG51">
                  <label for="anzahlZuzalungPG51">Menge (PG51)</label>
                </div>
              </div>
              <div class="col">
                <Date-Select LabelText="genehmigt bis" [(Date)]="Auftrag.ekv.genehmigtBis"></Date-Select>
              </div>
            </div>
            }
            <div class="row">
              <div class="col">
                <Date-Select LabelText="Abgelehnt" [(Date)]="Auftrag.ekv.abgelehnt.zeitpunkt"></Date-Select>
              </div>
              <div class="col">
                <GrundSelect [(selection)]="Auftrag.ekv.abgelehnt"></GrundSelect>
              </div>
            </div>


          </Auftrag-Card>
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="true" HeaderText="Genehmigung" *IsSpezialUser>


            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="genehmigung" [(ngModel)]="Auftrag.genehmigung.genehmigungsnummer">
                  <label for="genehmigung">Genehmigungsnummer</label>
                </div>
              </div>
              <div class="col">
                <Date-Select LabelText="Genehmigungs Datum" [(Date)]="Auftrag.genehmigung.genehmigungsDatum"></Date-Select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="HilfsmittelNr" [(ngModel)]="Auftrag.genehmigung.hilfsmittelnummer">
                  <label for="HilfsmittelNr">Hilfsmittelnummer</label>
                </div>
              </div>
            </div>

          </Auftrag-Card>

          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="ShowPG52" HeaderText="Gerät / Leitstelle" *IsSpezialUser>

            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="geraeteID" [ngModel]="Auftrag.geraet?.geraeteID" readonly disabled>
                  <label for="geraeteID">Geräte-ID</label>
                </div>
              </div>
              <div class="col">
                <SeriennummerSelect [(selection)]="Auftrag.geraet" [enabeld]="CanSetSerial"></SeriennummerSelect>
              </div>
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="ClipID" [ngModel]="Auftrag.geraet?.clipID" readonly disabled>
                  <label for="ClipID">Clip-ID</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="Hausnotrufmodell" [ngModel]="Auftrag.geraet?.hilfsmittelnummer" readonly disabled>
                  <label for="Hausnotrufmodell">Hilfsmittelnummer (Gerät)</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="Hausnotrufmodell" [ngModel]="Auftrag.geraet?.model?.name" readonly disabled>
                  <label for="Hausnotrufmodell">Hausnotrufmodell</label>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col">
                <Date-Select LabelText="Leitstelle Versand" [(Date)]="Auftrag.leitstelle.versand"></Date-Select>
              </div>
              <div class="col">
                <Date-Select LabelText="Leitstelle Bestätigt" [(Date)]="Auftrag.leitstelle.bestaetigt"></Date-Select>
              </div>
              <div class="col-auto">
                <div class="btn btn-primary" (click)="setBestaetigt()" style="line-height: 43px;">Leitstelle Angemeldet</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="Leitsetlle" [(ngModel)]="Auftrag.leitstelle.name" readonly disabled>
                  <label for="Leitsetlle">Leitstelle</label>
                </div>
              </div>
            </div>

          </Auftrag-Card>

        </div>
        <div class="col">
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="ShowPG52" HeaderText="Versand" *IsSpezialUser>

            <div class="row">
              <div class="col">
                <Date-Select LabelText="Versand" [(Date)]="Auftrag.versand.paketVersand"></Date-Select>
              </div>
              <div class="col">
                <Date-Select LabelText="Geliefert" [(Date)]="Auftrag.versand.geliefert"></Date-Select>
              </div>
            </div>

          </Auftrag-Card>
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="ShowPG52" HeaderText="Abrechnung" *IsSpezialUser>

            <div class="row">
              <div class="col">
                <Date-Select LabelText="INBR" [(Date)]="Auftrag.abrechnung.inbetriebnahme"></Date-Select>
              </div>
              <div class="col">
                <!--Cehckbox Unterschrift erfolgt-->
                <div class="form-check mb-3">
                  <input name="PG51Zuzahlung" id="PG51Zuzahlung" class="form-check-input" type="checkbox" [disabled]="!CanSetUnterschriftErvolgt" [readonly]="!CanSetUnterschriftErvolgt"
                         [checked]="Auftrag.abrechnung.unterschriftErfolgt"
                         (change)="Auftrag.abrechnung.unterschriftErfolgt = !Auftrag.abrechnung.unterschriftErfolgt" />
                  <label for="PG51Zuzahlung" class="form-check-label">Unterschrift erfolgt</label>
                </div>
              </div>
            </div>

          </Auftrag-Card>
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="true" HeaderText="Beendigung, Rückabwicklung" *IsSpezialUser>

            <div class="row">
              <div class="col">
                <Date-Select LabelText="Rückholung" [(Date)]="Auftrag.beendigung.ruekholung.zeitpunkt"></Date-Select>
              </div>
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="RuekholungGrund" [(ngModel)]="Auftrag.beendigung.ruekholung.grund">
                  <label for="RuekholungGrund">Rückholung Grund</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <Date-Select LabelText="Widerruf" [(Date)]="Auftrag.beendigung.widerruf.zeitpunkt"></Date-Select>
              </div>
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="WiderrufGrund" [(ngModel)]="Auftrag.beendigung.widerruf.grund">
                  <label for="WiderrufGrund">Widerruf Grund</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <Date-Select LabelText="Storno" [(Date)]="Auftrag.beendigung.storno.zeitpunkt"></Date-Select>
              </div>
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="StornoGrund" [(ngModel)]="Auftrag.beendigung.storno.grund">
                  <label for="StornoGrund">Storno Grund</label>
                </div>
              </div>
            </div>

          </Auftrag-Card>
          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="ShowPG52" HeaderText="Welcome Call">

            <div class="row">
              <div class="col">
                <Date-Select LabelText="Wellcome Call" [(Date)]="Auftrag.ekv.wellcomeCall" [enabeld]="CanSetWeellcomeCall"></Date-Select>
              </div>
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="number" class="form-control" id="anzahlVersucheWellcomecall" [(ngModel)]="Auftrag.wellcomeCall.anzahlVersucheWellcomecall">
                  <label for="anzahlVersucheWellcomecall">Counter</label>
                </div>
              </div>
              <div class="col">
                <Date-Select LabelText="Letzter Call" [(Date)]="Auftrag.wellcomeCall.letzterVersucheWellcomecall"></Date-Select>
              </div>
              <div class="col-auto">
                <div class="btn btn-primary" (click)="KALClieck()" style="line-height: 44px;">
                  KAL
                </div>
              </div>
            </div>

          </Auftrag-Card>

          <Auftrag-Card [Auftrag]="Auftrag" [IsVisible]="true" HeaderText="" *IsSpezialUser>

            <div class="row">
              <div class="col">
                <KooperationspartnerSelect [(selection)]="Auftrag.kooperationspartner" style="
    width: 100%;
    display: block;
"></KooperationspartnerSelect>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="LEAgent" [(ngModel)]="Auftrag.leAgend">
                  <label for="LEAgent">LE Agent (User)</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="CCAgent" [(ngModel)]="Auftrag.ccAgend">
                  <label for="CCAgent">CC-Agent</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" disabled readonly [ngModel]="Auftrag.zuletztGeaendert">
                </div>
              </div>
            </div>

          </Auftrag-Card>
        </div>
        <div class="col-auto FlyoutCol">

        </div>
      </div>
    </div>
  </div>
  <div class="row CommandBar">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-success" (click)="UpdateOrder()">Speichern</div>
    </div>
  </div>
  }
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
<ng-template #errorTpl> Fehler beim Speichern! </ng-template>
